import { useState, useEffect } from 'react';

function useWindowSize () {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    function updateSize () {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    }

    updateSize();
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return { width, height };
}

export default useWindowSize;
